import { Button } from '@chakra-ui/react';
import { rem } from 'polished';

interface Props {
  page: number;
  currentPage: number;
  onClick: (page: number) => void;
  isLoading: boolean;
}

export const PaginationButton = ({ page, currentPage, onClick, isLoading }: Props) => {
  const isActive = currentPage === page;

  return (
    <Button
      minW="unset"
      boxSize={{ base: rem(28), md: rem(38) }}
      p={0}
      onClick={() => !isActive && onClick(page)}
      fontSize={{ base: 'xs', md: 'md' }}
      fontWeight="bold"
      isLoading={isActive && isLoading}
      {...(!isActive && {
        bg: 'gray.1',
        color: 'gray.4',
        _hover: { bg: 'gray.2' },
        _active: { bg: 'gray.2' },
      })}
    >
      {page}
    </Button>
  );
};
